const PENDING_BILLING_PLAN_KEY = "verdictia_pending_billing_plan";

const PUBLIC_PLAN_CODES = new Set(["trial", "entrepreneur", "solo", "pro"]);
const PAID_PLAN_CODES = new Set(["entrepreneur", "solo", "pro"]);

const getStorage = () => {
    try {
        return window.sessionStorage;
    } catch {
        return null;
    }
};

export function normalizePublicPlan(value) {
    const normalized = String(value || "").trim().toLowerCase();
    return PUBLIC_PLAN_CODES.has(normalized) ? normalized : null;
}

export function isPaidPlan(plan) {
    const normalized = normalizePublicPlan(plan);
    return Boolean(normalized && PAID_PLAN_CODES.has(normalized));
}

export function savePendingBillingPlan(plan) {
    const normalized = normalizePublicPlan(plan);
    const storage = getStorage();

    if (!storage) {
        return normalized;
    }

    if (normalized) {
        storage.setItem(PENDING_BILLING_PLAN_KEY, normalized);
    } else {
        storage.removeItem(PENDING_BILLING_PLAN_KEY);
    }

    return normalized;
}

export function getPendingBillingPlan() {
    const storage = getStorage();
    if (!storage) {
        return null;
    }

    const normalized = normalizePublicPlan(storage.getItem(PENDING_BILLING_PLAN_KEY));
    if (!normalized) {
        storage.removeItem(PENDING_BILLING_PLAN_KEY);
    }
    return normalized;
}

export function clearPendingBillingPlan() {
    const storage = getStorage();
    if (storage) {
        storage.removeItem(PENDING_BILLING_PLAN_KEY);
    }
}

export function savePendingBillingPlanFromSearch(search) {
    const params = new URLSearchParams(search || "");
    if (!params.has("plan")) {
        return null;
    }
    return savePendingBillingPlan(params.get("plan"));
}
